@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');
}

.zds-form-error {
	color: var(--zds-text-color-danger);
	display: block;
	font-weight: 600;
	margin-bottom: var(--zds-space-2);
}
